/* Myaar Heritage — theme scripts */
(function () {
  'use strict';

  // Constants
  var CART_UPDATE_DELAY = 500; // milliseconds
  var FETCH_TIMEOUT = 5000; // milliseconds
  var CART_ADD_TIMEOUT = 10000; // milliseconds for cart operations
  var MAX_GIFT_CANDLES = 24; // Maximum candles to display in gift builder

  var M = window.Myaar || { routes: {} };

  // Cart state
  var CartState = {
    itemCount: 0,
    items: [],
    totalPrice: 0
  };

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Cart API functions
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || M.moneyFormat || '₹{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      default: value = withDelimiters(cents, 2, ',', '.').replace(/\.00$/, '');
    }
    return match ? format.replace(match[0], value) : value;
  }

  // Show notification
  function showNotification(message, type) {
    var notification = document.getElementById('CartNotification');
    if (!notification) return;
    notification.textContent = message;
    notification.className = 'cart-notification cart-notification--' + (type || 'success');
    notification.hidden = false;
    setTimeout(function () {
      notification.hidden = true;
    }, 3000);
  }

  // Update cart count in header
  function updateCartCount(count) {
    var countEls = document.querySelectorAll('.cart-count');
    var bagLinks = document.querySelectorAll('[aria-label*="Bag"]');

    countEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });

    bagLinks.forEach(function (link) {
      link.setAttribute('aria-label', 'Bag, ' + count + ' items');
    });

    CartState.itemCount = count;
  }

  // Fetch cart state from Shopify
  function getCart() {
    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);

    return fetch(M.routes.cart + '.js', { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to fetch cart');
        return r.json();
      })
      .then(function (cart) {
        CartState.items = cart.items;
        CartState.totalPrice = cart.total_price;
        CartState.itemCount = cart.item_count;
        updateCartCount(cart.item_count);
        return cart;
      })
      .finally(function () {
        clearTimeout(timeoutId);
      });
  }

  // Add item to cart
  function addToCart(formData) {
    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, CART_ADD_TIMEOUT);

    return fetch(M.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(formData),
      signal: controller.signal
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || 'Could not add to bag');
        return getCart().then(function () { return res.data; });
      })
      .finally(function () {
        clearTimeout(timeoutId);
      });
  }

  // Update cart item quantity
  function updateCartItem(lineKey, quantity) {
    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, CART_ADD_TIMEOUT);

    return fetch(M.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
      signal: controller.signal
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to update cart');
        return r.json();
      })
      .then(function (cart) {
        CartState.items = cart.items;
        CartState.totalPrice = cart.total_price;
        CartState.itemCount = cart.item_count;
        updateCartCount(cart.item_count);
        return cart;
      })
      .finally(function () {
        clearTimeout(timeoutId);
      });
  }

  // "Complete the gift": candles not yet in the bag
  var UPSELL_COUNT = 2;

  function renderCartUpsell(cart) {
    var container = document.querySelector('[data-cart-upsell]');
    if (!container) return;
    var inBag = cart.items.map(function (item) { return item.handle; });
    var picks = (M.candles || []).filter(function (c) {
      return c.available && c.variantId && inBag.indexOf(c.handle) === -1;
    }).slice(0, UPSELL_COUNT);

    // Suggestions only make sense once something is in the bag
    container.hidden = cart.item_count === 0 || picks.length === 0;
    if (container.hidden) return;
    container.innerHTML = '<p class="cart-upsell__heading">Complete the gift</p>' +
      picks.map(function (c) {
        return '<div class="cart-upsell__item">' +
          '<img src="' + c.image + '" alt="' + escapeHtml(c.title) + '" loading="lazy" width="800" height="1000">' +
          '<div class="cart-upsell__info"><span class="cart-upsell__title">' + escapeHtml(c.title) + '</span><span class="small muted">' + formatMoney(c.price) + '</span></div>' +
          '<button type="button" class="btn btn--outline btn--sm" data-upsell-add="' + c.variantId + '" aria-label="Add ' + escapeHtml(c.title) + ' to bag">+ Add</button>' +
        '</div>';
      }).join('');
  }

  // Render cart drawer content
  function renderCartDrawer(cart) {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var itemsContainer = drawer.querySelector('[data-cart-items]');
    var emptyState = drawer.querySelector('[data-cart-empty]');
    var footer = drawer.querySelector('[data-cart-footer]');
    var totalEl = drawer.querySelector('[data-cart-total]');
    var countEl = drawer.querySelector('[data-cart-drawer-count]');
    if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

    if (cart.item_count === 0) {
      if (itemsContainer) itemsContainer.hidden = true;
      if (footer) footer.hidden = true;
      if (emptyState) emptyState.hidden = false;
      renderCartUpsell(cart);
      return;
    }

    if (emptyState) emptyState.hidden = true;
    if (footer) footer.hidden = false;
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    if (itemsContainer) {
      itemsContainer.hidden = false;
      itemsContainer.innerHTML = cart.items.map(function (item, index) {
        var fallbackImage = (M.productImages || {})[item.handle];
        var imageSrc = item.image || fallbackImage;
        var imageHtml = imageSrc
          ? '<img src="' + imageSrc + '" alt="' + item.product_title + '" loading="lazy" width="800" height="1000">'
          : '';

        var variant = item.product_has_only_default_variant ? '' : '<p class="small muted">' + item.variant_title + '</p>';

        var properties = '';
        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            if (key[0] !== '_' && item.properties[key]) {
              properties += '<p class="cart-drawer-item__prop"><span>' + escapeHtml(key) + ':</span> ' + escapeHtml(item.properties[key]) + '</p>';
            }
          });
        }

        return '<div class="cart-drawer-item" data-cart-item="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-drawer-item__image media media--square" tabindex="-1">' +
            imageHtml +
          '</a>' +
          '<div class="cart-drawer-item__info">' +
            '<div class="cart-drawer-item__top">' +
              '<a href="' + item.url + '" class="cart-drawer-item__title">' + item.product_title + '</a>' +
              '<span class="cart-drawer-item__price" data-line-price="' + item.key + '">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            variant + properties +
            '<div class="cart-drawer-item__footer">' +
              '<div class="qty qty--small">' +
                '<button type="button" class="qty__btn" data-qty-change="-1" data-line-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
                '<input type="number" class="qty__input" value="' + item.quantity + '" min="0" readonly aria-label="Quantity">' +
                '<button type="button" class="qty__btn" data-qty-change="1" data-line-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="cart-drawer-item__remove" data-cart-remove="' + item.key + '" aria-label="Remove ' + item.product_title + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
    }

    renderCartUpsell(cart);
  }

  // Open cart drawer
  function openCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    getCart()
      .then(function (cart) {
        renderCartDrawer(cart);
        drawer.hidden = false;
        document.body.style.overflow = 'hidden';
      })
      .catch(function (err) {
        console.error('Failed to open cart:', err);
        showNotification('Failed to load cart', 'error');
      });
  }

  // Close cart drawer
  function closeCartDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
  }

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn || btn.hasAttribute('data-line-key')) return; // bag lines are handled by the cart drawer
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-change'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart auto-update on quantity change */
  document.querySelectorAll('form[data-cart-form]').forEach(function (form) {
    var timer;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, CART_UPDATE_DELAY);
    });
  });

  /* Collection sorting */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Product gallery */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (main && src) {
          main.src = src;
          if (srcset) main.srcset = srcset; else main.removeAttribute('srcset');
          main.alt = thumb.getAttribute('data-alt') || main.alt;
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

  /* Gift note toggle */
  document.querySelectorAll('[data-gift-toggle]').forEach(function (toggle) {
    var target = document.getElementById(toggle.getAttribute('aria-controls'));
    function sync() {
      if (!target) return;
      target.hidden = !toggle.checked;
      target.querySelectorAll('textarea, input').forEach(function (f) { f.disabled = !toggle.checked; });
    }
    toggle.addEventListener('change', sync);
    sync();
  });

  /* Variant picker */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var root = form.closest('[data-product]') || document;
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var labelEl = root.querySelector('[data-selected-option]');

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-input]')) return;
      var selected = [];
      form.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (labelEl) labelEl.textContent = selected.join(' · ');
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute('data-add') : addBtn.getAttribute('data-sold-out');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Product recommendations */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT);

    fetch(url, { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('Failed to load recommendations');
        return r.text();
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) {
          // Safe DOM manipulation - clear and append child nodes
          while (el.firstChild) el.removeChild(el.firstChild);
          while (fresh.firstChild) el.appendChild(fresh.firstChild);
        }
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') {
          console.warn('Could not load recommendations:', err.message);
        }
      })
      .finally(function () {
        clearTimeout(timeoutId);
      });
  });

  /* Gift box builder */
  document.querySelectorAll('[data-gift-builder]').forEach(function (builder) {
    var boxButtons = builder.querySelectorAll('[data-box]');
    var picks = builder.querySelectorAll('[data-candle]');
    var countEl = builder.querySelector('[data-picked-count]');
    var shortEl = builder.querySelector('[data-picked-short]');
    var boxNameEl = builder.querySelector('[data-box-name]');
    var totalEl = builder.querySelector('[data-total]');
    var addBtn = builder.querySelector('[data-builder-add]');
    var errorEl = builder.querySelector('[data-builder-error]');
    var state = { limit: 0, boxName: '', boxVariant: null, boxPrice: 0, picked: [] };

    function selectBox(btn) {
      boxButtons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      state.limit = parseInt(btn.getAttribute('data-count'), 10);
      state.boxName = btn.getAttribute('data-name');
      state.boxVariant = btn.getAttribute('data-variant') || null;
      state.boxPrice = parseInt(btn.getAttribute('data-price') || '0', 10);
      state.picked = state.picked.slice(0, state.limit);
      render();
    }

    function render() {
      var n = state.picked.length;
      var full = n >= state.limit;
      picks.forEach(function (p) {
        var id = p.getAttribute('data-variant');
        var on = state.picked.indexOf(id) !== -1;
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
        var demo = p.hasAttribute('data-demo');
        p.disabled = demo || (!on && full);
        var label = p.querySelector('[data-state]');
        if (label) label.textContent = demo ? 'Demo item' : (on ? '✓ Added' : (full ? 'Box is full' : '+ Add'));
      });
      if (countEl) countEl.textContent = n + ' of ' + state.limit + ' chosen';
      if (shortEl) shortEl.textContent = n + ' / ' + state.limit;
      if (boxNameEl) boxNameEl.textContent = state.boxName;
      var total = state.boxPrice;
      state.picked.forEach(function (id) {
        var p = builder.querySelector('[data-candle][data-variant="' + id + '"]');
        if (p) total += parseInt(p.getAttribute('data-price') || '0', 10);
      });
      if (totalEl) totalEl.textContent = formatMoney(total);
      if (addBtn) {
        var ready = n === state.limit && n > 0;
        addBtn.disabled = !ready;
        addBtn.textContent = ready ? addBtn.getAttribute('data-ready') : 'Choose ' + (state.limit - n) + ' more to continue';
      }
    }

    boxButtons.forEach(function (b) { b.addEventListener('click', function () { selectBox(b); }); });
    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        var id = p.getAttribute('data-variant');
        var i = state.picked.indexOf(id);
        if (i !== -1) state.picked.splice(i, 1);
        else if (state.picked.length < state.limit) state.picked.push(id);
        render();
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var to = (builder.querySelector('[name="gift_to"]') || {}).value || '';
        var from = (builder.querySelector('[name="gift_from"]') || {}).value || '';
        var message = (builder.querySelector('[name="gift_message"]') || {}).value || '';
        var props = { 'Gift box': state.boxName };
        if (to) props['To'] = to;
        if (from) props['From'] = from;
        if (message) props['Gift note'] = message;
        var items = state.picked.map(function (id) {
          return { id: parseInt(id, 10), quantity: 1, properties: { 'Gift box': state.boxName } };
        });
        if (state.boxVariant) items.unshift({ id: parseInt(state.boxVariant, 10), quantity: 1, properties: props });
        else if (items.length) items[0].properties = props;
        addBtn.disabled = true;

        var controller = new AbortController();
        var timeoutId = setTimeout(function () { controller.abort(); }, CART_ADD_TIMEOUT);

        fetch(M.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
          signal: controller.signal
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || 'Could not add to bag');
            window.location.href = M.routes.cart;
          })
          .catch(function (err) {
            var message = err.name === 'AbortError'
              ? 'Request timed out. Please try again.'
              : err.message || 'Could not add to bag. Please try again.';
            if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
            render();
          })
          .finally(function () {
            clearTimeout(timeoutId);
          });
      });
    }

    if (boxButtons.length) selectBox(builder.querySelector('[data-box][aria-pressed="true"]') || boxButtons[0]);
  });

  /* Cart drawer controls */
  // Open cart drawer when clicking cart icon
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('a[href*="/cart"]');
    if (cartLink && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      openCartDrawer();
    }
  });

  // Close cart drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      closeCartDrawer();
    }
  });

  // Cart drawer quantity changes
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change][data-line-key]');
    if (!btn) return;

    var lineKey = btn.getAttribute('data-line-key');
    var change = parseInt(btn.getAttribute('data-qty-change'), 10);
    var itemEl = btn.closest('[data-cart-item]');
    var input = itemEl && itemEl.querySelector('.qty__input');
    if (!input) return;

    var currentQty = parseInt(input.value, 10) || 0;
    var newQty = Math.max(0, currentQty + change);

    var loadingEl = document.querySelector('[data-cart-loading]');
    if (loadingEl) loadingEl.hidden = false;

    updateCartItem(lineKey, newQty)
      .then(function (cart) {
        renderCartDrawer(cart);
        if (newQty === 0) {
          showNotification('Item removed from bag', 'success');
        }
      })
      .catch(function (err) {
        showNotification(err.message || 'Failed to update cart', 'error');
      })
      .finally(function () {
        if (loadingEl) loadingEl.hidden = true;
      });
  });

  // Add a suggested candle from the bag
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    btn.disabled = true;
    addToCart({ items: [{ id: Number(btn.getAttribute('data-upsell-add')), quantity: 1 }] })
      .then(getCart)
      .then(renderCartDrawer)
      .catch(function (err) {
        btn.disabled = false;
        showNotification(err.message || 'Could not add to bag', 'error');
      });
  });

  // Remove from cart
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;

    var lineKey = btn.getAttribute('data-cart-remove');
    var loadingEl = document.querySelector('[data-cart-loading]');
    if (loadingEl) loadingEl.hidden = false;

    updateCartItem(lineKey, 0)
      .then(function (cart) {
        renderCartDrawer(cart);
        showNotification('Item removed from bag', 'success');
      })
      .catch(function (err) {
        showNotification(err.message || 'Failed to remove item', 'error');
      })
      .finally(function () {
        if (loadingEl) loadingEl.hidden = true;
      });
  });

  /* AJAX add to cart for product forms */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.closest('[data-gift-builder]')) return; // Skip gift builder

    e.preventDefault();

    var formData = {
      items: [{
        id: form.querySelector('[name="id"]').value,
        quantity: parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10)
      }]
    };

    // Add properties if any
    var properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (input) {
      var match = input.name.match(/properties\[(.+)\]/);
      if (match && input.value) {
        properties[match[1]] = input.value;
      }
    });
    if (Object.keys(properties).length > 0) {
      formData.items[0].properties = properties;
    }

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    addToCart(formData)
      .then(function () {
        showNotification('Added to bag', 'success');
        openCartDrawer();
      })
      .catch(function (err) {
        showNotification(err.message || 'Could not add to bag', 'error');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-add') || 'Add to bag';
        }
      });
  });

  // Sliders: homepage reviews and product card photos
  var SLIDER_AUTOPLAY_DELAY = 6000; // milliseconds

  function initSlider(slider) {
    var track = slider.querySelector('[data-slider-track]');
    var slides = track ? track.children : [];
    var dots = slider.querySelectorAll('[data-slider-dot]');
    if (slides.length < 2 || slider.hasAttribute('data-slider-ready')) return;
    slider.setAttribute('data-slider-ready', '');

    function currentIndex() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(index) {
      var count = slides.length;
      var next = (index + count) % count;
      track.scrollTo({ left: next * track.clientWidth });
    }

    function updateDots() {
      var index = currentIndex();
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    slider.querySelector('[data-slider-prev]').addEventListener('click', function () { goTo(currentIndex() - 1); });
    slider.querySelector('[data-slider-next]').addEventListener('click', function () { goTo(currentIndex() + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(Number(dot.getAttribute('data-slider-dot'))); });
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(updateDots); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(currentIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(currentIndex() + 1); }
    });

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (slider.getAttribute('data-autoplay') !== 'true' || reduceMotion) return;

    var paused = false;
    ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
      slider.addEventListener(evt, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (evt) {
      slider.addEventListener(evt, function () { paused = false; });
    });
    setInterval(function () {
      if (!paused && !document.hidden) goTo(currentIndex() + 1);
    }, SLIDER_AUTOPLAY_DELAY);
  }

  function initSliders(root) {
    root.querySelectorAll('[data-quote-slider], [data-card-slider]').forEach(initSlider);
  }

  initSliders(document);
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });

  // Initialize cart count on page load
  getCart().catch(function () {
    console.warn('Failed to initialize cart');
  });
})();
